import { render, staticRenderFns } from "./vsUploadCustom.vue?vue&type=template&id=590f477f"
import script from "./vsUploadCustom.vue?vue&type=script&lang=js"
export * from "./vsUploadCustom.vue?vue&type=script&lang=js"
import style0 from "./vsUploadCustom.vue?vue&type=style&index=0&id=590f477f&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590f477f')) {
      api.createRecord('590f477f', component.options)
    } else {
      api.reload('590f477f', component.options)
    }
    module.hot.accept("./vsUploadCustom.vue?vue&type=template&id=590f477f", function () {
      api.rerender('590f477f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsUploadCustom/vsUploadCustom.vue"
export default component.exports